module.exports = __webpack_public_path__ + "static/media/guardian_video-hero-img.cd68189b.webp";